<template>
  <div>
    <ActionsDropdown
      :actions="actions"
      @toDriverForm="handleClick('toDriverForm')"
      @setActivation="handleClick('setActivation')"
      @setValidation="handleClick('setValidation')"
      @resendEmail="handleClick('resendEmail')">
      <slot></slot>
    </ActionsDropdown>
  </div>
</template>

<script>
import ActionsDropdown from './ActionsDropdown.vue';

import driverDetailService from '../services/pages/driverForm.js';

import user from '../services/user/user.js';

export default {
  components: {
    ActionsDropdown,
  },
  props: {
    driver: Object,
    additionalActions: [],
  },
  data() {
    return {
      user: undefined,
      currentValues: {
        active: '',
        validated: '',
      },
      actions: [
        // { name: 'Resend Validation Email', callback: 'resendEmail' },
      ]
    }
  },
  methods: {
    setCurrentValues() {
      // used to track initial values rather than toggled ones
      this.currentValues.active = this.driver.active
      this.currentValues.validated = this.driver.validated
    },
    async handleClick(action) {
      let value
      if(action === 'setActivation') {
        value = !this.currentValues.active
      } else if(action === 'setValidation') {
        value = !this.currentValues.validated
      } else if (action === 'resendEmail') {
        value = true
      } else if(action === 'toDriverForm') {
        this.$router.push({ name: 'DriverForm', params: { id: this.driver.id } })
        return
      }

      await driverDetailService.putDriverDetail(this.driver.id, {'action': action, 'value': value})
    },
  },
  computed: {
    activatedStatus() {
      return this.driver.active ? 'Deactivate Driver' : 'Activate Driver'
    },
    validatedStatus() {
      return this.driver.validated ? 'Invalidate Driver' : 'Validate Driver'
    }
  },
  async mounted() {
    this.user = await user.get()
    if (driverDetailService.canActivateDriver(this.user) && this.driver.validated) {
      this.actions.unshift({ name: this.activatedStatus, callback: 'setActivation' })
    }
    if (driverDetailService.canValidateDriver(this.user)) {
      this.actions.unshift({ name: this.validatedStatus, callback: 'setValidation' })
    }
    if (this.additionalActions && this.additionalActions.length > 0) {
      this.actions = this.additionalActions.concat(this.actions)
    }
    this.setCurrentValues()
  },
}
</script>